// MainPage
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAllItemsEmptyUser } from '../actions/mainActions/mainAction';
import { getPublicFeaturedProductItemByType } from '../actions/publicFeaturedProductItem.action';
import { setShowModalUser } from '../reducers/auth.reducer';
import RenderItems from './RenderItems';
import Loader from './../components/Loader';
import FooterMainPage from './FooterMainPage';
import HeaderMainPage from './HeaderMainPage';
import { generatePublicUrl } from '../urlConfig';

const guestEntryActions = [
    {
        title: "Обычный пользователь",
        text: "Каталог, корзина, избранное, заказы, заявки и подбор изделий.",
        badge: "Сайт",
        role: "user"
    },
    {
        title: "Офисы и партнёры",
        text: "3D-сборщик, офисы, клиенты, заказы, подписки и товары офиса.",
        badge: "Офис / 3D",
        role: "partner"
    },
    {
        title: "Город и администрации",
        text: "МАФы, благоустройство, городские проекты и комплексные поставки.",
        badge: "Город",
        role: "cityAdmin"
    }
];

const roleDashboardConfig = {
    user: {
        badge: "Личный кабинет",
        title: "Подбор изделий, заявки и каталог",
        text: "Вы можете смотреть каталог, сохранять товары, оформлять заявки, работать с заказами и использовать 3D-подбор для будущего проекта.",
        accent: "user",
        stats: [
            { value: "Каталог", label: "Товары и категории" },
            { value: "3D", label: "Подбор сцены" },
            { value: "Заявки", label: "Связь с производством" }
        ],
        actions: [
            { title: "Открыть каталог", text: "Перейти к товарам и категориям.", href: "/productsCategory/all" },
            { title: "Избранное", text: "Посмотреть сохранённые товары.", href: "/desiresPage" },
            { title: "Мои заказы", text: "История и статусы заказов.", href: "/orderPage" },
            { title: "Мои заявки", text: "Заявки на расчёт и обращения.", href: "/applicationPage" },
            { title: "Настройки профиля", text: "Данные, email, рассылка и пароль.", href: "/personalInformation" },
            { title: "3D-сборщик", text: "Собрать комплект и сцену.", href: "/fenceCalculator" }
        ]
    },
    partner: {
        badge: "Партнёр / офис",
        title: "Рабочая зона партнёра и офиса",
        text: "Здесь собраны быстрые входы в управление офисами, 3D-сборщик, заявки, чаты, подписку и производственные сценарии.",
        accent: "partner",
        stats: [
            { value: "Офисы", label: "Рабочие точки" },
            { value: "3D", label: "Сборщик сцен" },
            { value: "Заказы", label: "Клиенты и заявки" }
        ],
        actions: [
            { title: "Открыть панель офиса", text: "Управление офисами, заказами и сотрудниками.", href: "/adminLayout" },
            // { title: "3D-сборщик сцен", text: "Собрать сцену, комплект и визуализацию.", href: "/fenceCalculator" },
            { title: "Профиль и подписка", text: "Баланс, тариф, данные и настройки.", href: "/personalInformation" },
            // { title: "Заявки", text: "Просмотреть обращения и заявки.", href: "/applicationPage" },
            // { title: "Чаты", text: "Открыть коммуникации с клиентами.", href: "/chat" },
            // { title: "Партнёрская страница", text: "Материалы и условия сотрудничества.", href: "/partnerPageSale" }
        ]
    },
    cityAdmin: {
        badge: "Город / администрация",
        title: "МАФы, благоустройство и городские проекты",
        text: "Для городских администраций и организаций — подбор МАФов, визуализация, заявки на проект, контакт с производством и комплексные решения.",
        accent: "city",
        stats: [
            { value: "МАФы", label: "Городская среда" },
            { value: "Проекты", label: "Подбор решений" },
            { value: "3D", label: "Визуализация" }
        ],
        actions: [
            { title: "Каталог МАФов", text: "Посмотреть изделия для городской среды.", href: "/productsCategory/all" },
            { title: "Заявка на проект", text: "Оставить обращение на расчёт или подбор.", href: "/applicationPage" },
            { title: "3D-визуализация", text: "Собрать сцену будущего объекта.", href: "/fenceCalculator" },
            { title: "Контакты", text: "Связаться с производством.", href: "/contacts" },
            { title: "Организационный профиль", text: "Данные, email, рассылки и настройки.", href: "/personalInformation" },
            { title: "Городские решения", text: "Перейти к разделу сотрудничества.", href: "/contactM" }
        ]
    },
    admin: {
        badge: "Администрирование",
        title: "Управление сайтом и рабочими процессами",
        text: "Быстрый вход в административную панель, заявки, товары, коммуникации и контроль пользовательских сценариев.",
        accent: "admin",
        stats: [
            { value: "Admin", label: "Управление" },
            { value: "Заявки", label: "Контроль" },
            { value: "Сайт", label: "Витрина" }
        ],
        actions: [
            { title: "Админ-панель", text: "Перейти в управление системой.", href: "/adminLayout" },
            { title: "Заявки", text: "Просмотреть заявки пользователей.", href: "/applicationPage" },
            { title: "Чаты", text: "Открыть коммуникации.", href: "/chat" },
            { title: "Каталог", text: "Проверить публичные товары.", href: "/productsCategory/all" },
            { title: "Профиль", text: "Настройки аккаунта.", href: "/personalInformation" },
            { title: "3D-сборщик", text: "Проверить сборщик сцен.", href: "/fenceCalculator" }
        ]
    }
};

const productionCards = [
    {
        title: "Памятники и мемориальные комплексы",
        text: "Гранит, 3D-дизайн, подбор элементов и визуализация перед изготовлением.",
        badge: "Гранит"
    },
    {
        title: "Ограды и изделия из металла",
        text: "Металлические ограды, плазморез, декоративные панели и реальные производственные размеры.",
        badge: "Металл"
    },
    {
        title: "МАФы и городская среда",
        text: "Скамейки, урны, вазоны, элементы благоустройства и комплексные решения для города.",
        badge: "МАФ"
    }
];

const platformSteps = [
    "Выберите сценарий работы: пользователь, партнёр или городская организация.",
    "Подберите товар, сцену или комплект через каталог и 3D-инструменты.",
    "Оставьте заявку, оформите заказ или продолжите работу через офисную панель."
];

const getId = (value) => {
    if (!value) {
        return "";
    }

    if (typeof value === "object") {
        return value._id || value.id || "";
    }

    return value;
};

const getRoleKey = (role) => {
    if (role === "partner" || role === "storeOwner" || role === "officeWorker") {
        return "partner";
    }

    if (role === "cityAdmin") {
        return "cityAdmin";
    }

    if (role === "admin" || role === "superAdmin") {
        return "admin";
    }

    return "user";
};

const getProductObject = (item) => {
    if (!item) {
        return {};
    }

    if (item.product && typeof item.product === "object") {
        return item.product;
    }

    if (item.productId && typeof item.productId === "object") {
        return item.productId;
    }

    return {};
};

const getProductImage = (item) => {
    const product = getProductObject(item);
    const mainPicture = Array.isArray(product.productPictures)
        ? product.productPictures.find((picture) => picture.mainImg || picture.visibleImg)
        : null;

    return (
        item?.img ||
        item?.selectedPicture?.img ||
        item?.reducedImage ||
        product?.reducedImage ||
        mainPicture?.img ||
        product?.productPictures?.[0]?.img ||
        ""
    );
};

const getProductHref = (item) => {
    const product = getProductObject(item);
    const productId = getId(product?._id || product?.id || item?.productId);

    if (productId) {
        return `/productDetails/${productId}`;
    }

    if (product?.categorySlug && product?.category) {
        return `/productsCategory/${product.categorySlug}?cid=${getId(product.category)}`;
    }

    if (product?.categorySlug) {
        return `/productsCategory/${product.categorySlug}`;
    }

    return "/productsCategory/all";
};

const getProductPrice = (product) => {
    if (product?.price === undefined || product?.price === null || product?.price === "") {
        return "";
    }

    return `${Number(product.price).toLocaleString("ru-RU")} ₽`;
};

const normalizeFeaturedProductsToSlides = (products) => {
    if (!Array.isArray(products)) {
        return [];
    }

    return products
        .filter((item) => item?.product || item?.productId || item?.img || item?.reducedImage || item?.selectedPicture)
        .map((item, index) => {
            const product = getProductObject(item);
            const image = getProductImage(item);
            const price = getProductPrice(product);

            return {
                id: getId(item._id || product._id) || `featured-${index}`,
                title: product.fullName || product.name || `Товар ${index + 1}`,
                text: product.description || product.descriptionNew || product.categoryName || "Товар из выбранной подборки.",
                badge: product.categoryName || "Товар",
                href: getProductHref(item),
                cta: "Перейти на товар",
                image,
                price,
                hasModel: Boolean(product.modelPath),
                article: product.article,
                variant: index % 4 === 0
                    ? "granite"
                    : index % 4 === 1
                        ? "metal"
                        : index % 4 === 2
                            ? "maf"
                            : "scene"
            };
        });
};

const MainPage = ({ setShowFooter }) => {
    const {
        mainPages,
        loading
    } = useSelector((state) => state.mainPage);

    const {
        products: publicFeaturedProducts,
        loading: publicFeaturedLoading
    } = useSelector((state) => state.publicFeaturedProductItem || {
        products: [],
        loading: false,
        itemObj: {}
    });

    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const [activeSlideIndex, setActiveSlideIndex] = useState(0);

    const isAuth = !!auth.authenticate;
    const user = auth.user || {};
    const roleKey = getRoleKey(user.role);
    const roleConfig = roleDashboardConfig[roleKey];

    useEffect(() => {
        if (setShowFooter) {
            setShowFooter(false);
        }
    }, [setShowFooter]);

    useEffect(() => {
        dispatch(getAllItemsEmptyUser("mainPage"));
        dispatch(getPublicFeaturedProductItemByType("main-page-hero", "false"));
    }, [dispatch]);

    const productSlides = useMemo(() => {
        return normalizeFeaturedProductsToSlides(publicFeaturedProducts);
    }, [publicFeaturedProducts]);

    useEffect(() => {
        if (!productSlides.length) {
            return undefined;
        }

        const timer = setInterval(() => {
            setActiveSlideIndex((state) => (
                state + 1 >= productSlides.length ? 0 : state + 1
            ));
        }, 5000);

        return () => clearInterval(timer);
    }, [productSlides.length]);

    useEffect(() => {
        if (activeSlideIndex >= productSlides.length && productSlides.length > 0) {
            setActiveSlideIndex(0);
        }
    }, [activeSlideIndex, productSlides.length]);

    const activeSlide = productSlides[activeSlideIndex];

    const openRegistration = (role) => {
        dispatch(setShowModalUser({
            forceShow: true,
            mode: "signup",
            role
        }));
    };

    const openLogin = () => {
        dispatch(setShowModalUser({
            forceShow: true,
            mode: "login",
            role: "user"
        }));
    };

    const renderProductShowcase = (compact = false) => (
        <div className={`mainPage__productShowcase ${compact ? "mainPage__productShowcase--compact" : ""} mainPage__productShowcase--${activeSlide?.variant || "empty"}`}>
            {publicFeaturedLoading ? (
                <div className="mainPage__productEmpty">
                    <span>Загрузка подборки</span>
                    <p>Получаем товары из списка main-page-hero</p>
                </div>
            ) : productSlides.length > 0 && activeSlide ? (
                <>
                    <div className="mainPage__productTop">
                        <span className="mainPage__eyebrow">
                            {activeSlide.badge}
                        </span>

                        <div className="mainPage__sliderCounter">
                            {String(activeSlideIndex + 1).padStart(2, "0")}
                            <span>/</span>
                            {String(productSlides.length).padStart(2, "0")}
                        </div>
                    </div>

                    <div className="mainPage__productMedia">
                        {productSlides.map((slide, index) => (
                            slide.image ? (
                                <img
                                    key={`slide-img-${slide.id}-${index}`}
                                    className={`mainPage__productImage ${index === activeSlideIndex ? "active" : ""}`}
                                    src={generatePublicUrl(slide.image)}
                                    alt={slide.title}
                                />
                            ) : (
                                <div
                                    key={`slide-empty-${slide.id}-${index}`}
                                    className={`mainPage__productNoImage ${index === activeSlideIndex ? "active" : ""}`}
                                >
                                    <span>Нет фото</span>
                                </div>
                            )
                        ))}

                        <div className="mainPage__productInfoBadges">
                            {activeSlide.article && (
                                <span>Арт. {activeSlide.article}</span>
                            )}

                            <span>
                                {activeSlide.hasModel ? "3D модель есть" : "Без 3D модели"}
                            </span>
                        </div>
                    </div>

                    <div className="mainPage__productContent" key={activeSlide.id}>
                        <h2>{activeSlide.title}</h2>
                        <p>{activeSlide.text}</p>

                        <div className="mainPage__productMeta">
                            {activeSlide.price ? (
                                <strong>{activeSlide.price}</strong>
                            ) : (
                                <strong>Цена по запросу</strong>
                            )}
                        </div>

                        <div className="mainPage__productFooter">
                            <a href={activeSlide.href} className="mainPage__ctaButton">
                                {activeSlide.cta}
                            </a>

                            <div className="mainPage__sliderDots">
                                {productSlides.map((item, index) => (
                                    <button
                                        type="button"
                                        key={`${item.id}-${index}`}
                                        className={index === activeSlideIndex ? "active" : ""}
                                        onClick={() => setActiveSlideIndex(index)}
                                        aria-label={item.title}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="mainPage__productEmpty">
                    <span>Подборка не настроена</span>

                    <p>
                        Создай в админке список товаров с типом main-page-hero,
                        добавь товары и включи видимость.
                    </p>

                    <a href="/productsCategory/all" className="mainPage__ctaButton">
                        Открыть каталог
                    </a>
                </div>
            )}
        </div>
    );

    const renderGuestHero = () => (
        <section className="mainPage__hero">
            <div className="mainPage__brandBlock">
                <div className="mainPage__logoMark">
                    <span></span>
                </div>

                <div className="mainPage__brandText">
                    <span>Производство / 3D / дизайн</span>
                    <h1>ALOTB</h1>
                </div>
            </div>

            <div className="mainPage__heroGrid">
                {renderProductShowcase()}

                <div className="mainPage__entryPanel">
                    <div className="mainPage__entryHeader">
                        <span>Вход на платформу</span>
                        <p>Выберите сценарий работы или войдите в уже созданный аккаунт</p>
                    </div>

                    <div className="mainPage__entryList">
                        {guestEntryActions.map((item, index) => (
                            <div
                                className="mainPage__entryItem"
                                key={item.role}
                                onClick={() => openRegistration(item.role)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        openRegistration(item.role);
                                    }
                                }}
                            >
                                <span className="mainPage__entryNumber">
                                    {String(index + 1).padStart(2, "0")}
                                </span>

                                <span className="mainPage__entryContent">
                                    <span className="mainPage__entryBadge">{item.badge}</span>
                                    <strong>{item.title}</strong>
                                    <small>{item.text}</small>
                                </span>
                            </div>
                        ))}
                    </div>

                    <button
                        type="button"
                        className="mainPage__loginButton"
                        onClick={openLogin}
                    >
                        Уже есть аккаунт — войти
                    </button>
                </div>
            </div>
        </section>
    );

    const renderRoleHero = () => (
        <section className={`mainPage__hero mainPage__hero--role mainPage__hero--${roleConfig.accent}`}>
            <div className="mainPage__roleHeroGrid">
                <div className="mainPage__roleHeroCard">
                    <span className="mainPage__eyebrow">
                        {roleConfig.badge}
                    </span>

                    <h1>
                        {roleConfig.title}
                    </h1>

                    <p>
                        {roleConfig.text}
                    </p>

                    {(!user.isActivated && !user.emailVerified) && (
                        <div className="mainPage__verifyNotice">
                            <strong>Email не подтверждён</strong>
                            <span>Подтвердите email в профиле, чтобы закрыть настройку аккаунта.</span>
                            <a href="/personalInformation">Перейти в профиль</a>
                        </div>
                    )}

                    <div className="mainPage__roleStats">
                        {roleConfig.stats.map((item) => (
                            <div className="mainPage__roleStat" key={item.label}>
                                <strong>{item.value}</strong>
                                <span>{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {renderProductShowcase(true)}
            </div>
        </section>
    );

    return (
        <div className="mainPageShell">
            <HeaderMainPage />

            <main className="mainPage">
                {isAuth ? renderRoleHero() : renderGuestHero()}

                {isAuth && (
                    <section className="mainPage__roleActionsSection">
                        <div className="mainPage__sectionHead">
                            <span>{roleConfig.badge}</span>
                            <h2>Быстрые действия</h2>
                        </div>

                        <div className="mainPage__roleActionGrid">
                            {roleConfig.actions.map((item) => (
                                <a
                                    className="mainPage__roleActionCard"
                                    href={item.href}
                                    key={item.title}
                                >
                                    <strong>{item.title}</strong>
                                    <span>{item.text}</span>
                                </a>
                            ))}
                        </div>
                    </section>
                )}

                <section className="mainPage__productionSection">
                    <div className="mainPage__sectionHead">
                        <span>Что делаем</span>
                        <h2>Производство, дизайн и цифровая сборка</h2>
                    </div>

                    <div className="mainPage__productionGrid">
                        {productionCards.map((item) => (
                            <div className="mainPage__productionCard" key={item.title}>
                                <span>{item.badge}</span>
                                <strong>{item.title}</strong>
                                <p>{item.text}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="mainPage__platformSection">
                    <div className="mainPage__platformCard">
                        <div>
                            <span className="mainPage__eyebrow">Платформа</span>
                            <h2>От идеи до заявки и производства</h2>
                            <p>
                                Сайт объединяет каталог, 3D-сборщик, заявки, офисную работу,
                                городские решения и производство изделий из камня и металла.
                            </p>
                        </div>

                        <div className="mainPage__platformSteps">
                            {platformSteps.map((item, index) => (
                                <div className="mainPage__platformStep" key={item}>
                                    <span>{String(index + 1).padStart(2, "0")}</span>
                                    <p>{item}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="mainPage__mainContent">
                    <div className="mainPage__sectionHead">
                        <span>Разделы сайта</span>
                        <h2>Выберите категорию</h2>
                    </div>

                    {!mainPages?.length || loading ? (
                        <Loader />
                    ) : (
                        <RenderItems mainPages={mainPages} />
                    )}
                </section>

                <FooterMainPage />
            </main>
        </div>
    );
};

export default MainPage;